module.exports = __webpack_public_path__ + "img/service.d497a4e7.png";